import { render, staticRenderFns } from "./MedicalCertificateList.vue?vue&type=template&id=6688d878"
import script from "./MedicalCertificateList.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports